import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap';
import { LabelErro } from './Layout/LabelErro'
import { LabelSucesso } from './Layout/LabelSucesso'
import ReactLoading from "react-loading";
import api from '../services/api';
import { Button, Form } from 'react-bootstrap';
import { URL } from '../constants/index'

class PrimeiroLogin extends Component {

    constructor(props) {
        super(props)

        this.state = {
            email: "",
            erroPrimeiroLogin: "",
            sucessoPrimeiroLogin: "",
            loading: false,
        }
    }

    handleEmail = e => {
        this.setState({ email: e.target.value })
    }

    onRetornarLogin = e => {
        this.props.history.push(URL.URLLogin)
    }

    startLoading() {
        this.setState({ loading: true })
    }

    stopLoading() {
        this.setState({ loading: false })
    }

    handlePrimeiroLogin = e => {
        e.preventDefault();

        if (!this.validarPrimeiroLogin()) {
            return false;
        }
        this.startLoading()

        api.post("/api/login/primeirologin", {
            email: this.state.email
        })
            .then(res => {
                this.tratarSucessoPrimeiroLogin()
                this.stopLoading()
            })
            .catch(err => {
                this.stopLoading()
                if (err.response && err.response.data) {
                    this.tratarErroPrimeiroLogin(err.response.data.message)
                } else {
                    this.tratarErroPrimeiroLogin("Erro ao se comunicar com API")
                }
            })


    }

    tratarSucessoPrimeiroLogin = e => {
        this.setState({
            sucessoPrimeiroLogin: "E-mail com instruções foi enviado com sucesso",
            erroPrimeiroLogin: ""
        })

    }

    validarPrimeiroLogin = e => {
        const { email } = this.state

        if (!email) {
            this.tratarErroPrimeiroLogin("Preencha e-mail para continuar")
            return false;
        }
        return true;
    }

    tratarErroPrimeiroLogin = erro => {
        this.setState({
            erroPrimeiroLogin: erro,
            sucessoPrimeiroLogin: ""
        })
    }

    render() {
        return (
            <Container style={{ paddingTop: "100px" }}>
                <Row className="justify-content-center">
                    <Col xs="6" style={{ padding: "20px" }} className="border" >
                        <Form onSubmit={this.handlePrimeiroLogin}>                        
                            <h3>Primeiro login</h3>
                            <h6>Informe seu e-mail para receber o token de autenticação</h6>
                            <hr/>
                            {this.state.erroPrimeiroLogin ? <LabelErro caption={this.state.erroPrimeiroLogin}></LabelErro> : null}
                            {this.state.sucessoPrimeiroLogin ? <LabelSucesso caption={this.state.sucessoPrimeiroLogin}></LabelSucesso> : null}
                            <Form.Group controlId="email">                            
                                <Form.Label>Email</Form.Label>                                
                                <Form.Control type="email" placeholder="Email" onChange={this.handleEmail} value={this.state.email} />
                            </Form.Group>

                            {!this.state.loading ?
                                <Button variant="dark" type="submit" block>Enviar</Button>                                
                                :
                                <Row className="justify-content-center">
                                    <ReactLoading type="bubbles" color="#343a40" height={100} width={100} />
                                </Row>
                            }
                        </Form>
                        <br />
                        <Button variant="dark" onClick={this.onRetornarLogin} block>Retornar para login</Button>                                                        
                    </Col>
                </Row>
            </Container>
        )
    }
}

export default PrimeiroLogin;